export enum HTTP_METHOD {
  GET,
  POST,
  PUT,
  DELETE,
  PATCH,
}

export const allowImgExt = ['jpeg', 'png', 'bmp', 'tiff', 'jpg'];

export const GENDERS = {
  MALE: 'male',
  FEMALE: 'female',
};

export const GENDER_OPTIONS = {
  male: 'member.male',
  female: 'member.female',
};

export const FILE_UPLOAD_ACCEPTABLE =
  'image/jpeg,image/jpg,image/png,image/bmp,image/tiff';

export const USER_TYPE = {
  STAFF: 'staff',
  CUSTOMER: 'customer',
};

export const USER_TYPE_OPTS: Option[] = [
  { label: '店員', value: 'STAFF' },
  { label: '顧客', value: 'CUSTOMER' },
];

export enum CHART_SETTING_VALUE {
  MAX_YAXIS = 20,
}

export enum FACE_DB_TYPE {
  Private = 'private',
  Cluster = 'cluster',
}

export enum FACE_ID_TYPE {
  Reference = 'reference',
  Anonymous = 'anonymous',
}

export const AGE_PIE_LABEL = {
  CHILDREN: '子供', // 0歳から9歳まで
  TEENAGERS: '10代', // 10歳から19歳まで
  TWENTIES: '20代', // 20歳から29歳まで
  THIRTIES: '30代', // 30歳から39歳まで
  FORTIES: '40代', //40歳から49歳まで
  FIFTIES: '50代', //50歳から59歳まで
  ELDERLY: '60以上', //60歳以上（60以上）
};

export const HIGH_CONTRAST_COLORS = [
  '#FB923C',
  '#02B2AF',
  '#2563EB',
  '#1E2A5E',
  '#F05A7E',
  '#C084FC',
  '#22C55E',
  '#8B0000',
  '#000000',
];
